"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _ResultModal = _interopRequireDefault(require("./ResultModal"));
var _modals = require("../../../utils/modals");
var mapStateToProps = function mapStateToProps(state, _ref) {
  var assetType = _ref.assetType,
    applicationPath = _ref.applicationPath;
  var currentContract = state.requestAccess.currentContract;
  return {
    applicationPath: applicationPath,
    currentContract: currentContract,
    isAPIGroup: assetType === 'api-group'
  };
};
var ResultModalContainer = (0, _redux.compose)((0, _modals.setModalName)('ResultModal'), (0, _reactRedux.connect)(mapStateToProps))(_ResultModal.default);
var _default = exports.default = ResultModalContainer;
//# sourceMappingURL=ResultModal.container.js.map